var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"navbar is-transparent"},[_c('Brand'),_c('Menu'),_c('Right')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }